// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class DepositWithdrawService extends BaseApi {


    constructor(){
        super();
    }

    async list(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/target-accounts`)
        .catch(this.handleErrorResponse);
    }

    async get(business, slug)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/target-accounts/${slug}`)
        .catch(this.handleErrorResponse);
    }


    async getWithdrawsSelect(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/catalogs/retiros`)
        .catch(this.handleErrorResponse);
    }

    async getDepositsSelect(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/catalogs/depositos`)
        .catch(this.handleErrorResponse);
    }



    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/target-accounts`, data)
        .catch(this.handleErrorResponse);
    }

    async update(business, slug, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/target-accounts/${slug}`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, slug)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/target-accounts/${slug}`)
        .catch(this.handleErrorResponse);
    }


}